export default __webpack_public_path__ + "static/media/060_corner2.first.0dba768a.webp";